module.exports = __webpack_public_path__ + "static/media/colorecta.7090eed3.svg";